import React, { useState, useEffect } from "react";
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
export default function CustomerModal({ isOpen, customer, onSave, onClose }) {
  const [initialCustomer, setInitialCustomer] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [noEmail, setNoEmail] = useState(false);
  // Fill fields when service is provided
  useEffect(() => {
    if (customer) {
      setInitialCustomer(customer || {});
      setErrors({});
    } else {
      clearForm();
    }
  }, [customer, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInitialCustomer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // Clears form fields
  const clearForm = () => {
    setInitialCustomer({
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
    });
    setErrors({});
    setNoEmail(false);
  };

  // Handle save
  const handleSave = (e) => {
    e.preventDefault();

    if (!validate()) return; // stop if invalid
    const updateCustomer = {
      ...initialCustomer,
      ...(noEmail && {
        email:
          initialCustomer.firstName.trim() +
          "." +
          initialCustomer.lastName.trim() +
          "@localhost.com",
      }),
    };

    onSave(updateCustomer); // send back to parent
  };
  // ✅ Validation rules
  const validate = () => {
    const newErrors = {};

    if (!initialCustomer.firstName || initialCustomer.firstName.trim() === "") {
      newErrors.firstName = "First name is required";
    }

    if (!initialCustomer.lastName || initialCustomer.lastName.trim() === "") {
      newErrors.lastName = "Last name is required";
    }

    if (
      !initialCustomer.phoneNumber ||
      initialCustomer.phoneNumber.trim() === ""
    ) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^[0-9]+$/.test(initialCustomer.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be digits only";
    } else if (initialCustomer.phoneNumber.length < 7) {
      newErrors.phoneNumber = "Phone number must be at least 7 digits";
    }
    if (!noEmail) {
      if (!initialCustomer.email || initialCustomer.email.trim() === "") {
        newErrors.email = "Email is required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(initialCustomer.email)
      ) {
        newErrors.email = "Invalid email format";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ valid if no errors
  };
  return (
    <div className={`modal  ${isOpen ? "show" : ""}`} tabindex="-1">
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">New Customer</h5>
          </div>
          <div className="modal-body">
            <div className="row m-2">
              <div className="col-12 m-3">
                <label className="form-label form-control-label">
                  First name
                </label>
                <input
                  type="text"
                  name="firstName"
                  className={`form-control form-input ${
                    errors.firstName ? "is-invalid" : ""
                  }`}
                  value={initialCustomer.firstName}
                  onChange={handleChange}
                />
                {errors.firstName && (
                  <div className="text-danger mt-1">{errors.firstName}</div>
                )}
              </div>

              <div className="col-12 m-3">
                <label className="form-label form-control-label">
                  Last name
                </label>
                <input
                  type="text"
                  name="lastName"
                  className={`form-control form-input ${
                    errors.lastName ? "is-invalid" : ""
                  }`}
                  value={initialCustomer.lastName}
                  onChange={handleChange}
                />
                {errors.lastName && (
                  <div className="text-danger mt-1">{errors.lastName}</div>
                )}
              </div>

              <div className="col-12 m-3">
                <label className="form-label form-control-label">
                  Phone number
                </label>
                <input
                  type="text"
                  name="phoneNumber"
                  className={`form-control form-input ${
                    errors.phoneNumber ? "is-invalid" : ""
                  }`}
                  value={initialCustomer.phoneNumber}
                  onChange={handleChange}
                />
                {errors.phoneNumber && (
                  <div className="text-danger mt-1">{errors.phoneNumber}</div>
                )}
              </div>

              <div className="col-12 m-3">
                <label className="form-label form-control-label">Email</label>
                <input
                  type="text"
                  name="email"
                  className={`form-control form-input ${
                    errors.email ? "is-invalid" : ""
                  }`}
                  value={initialCustomer.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <div className="text-danger mt-1">{errors.email}</div>
                )}
              </div>
              <div className="col-12 m-3 form-control-container">
                <label className="form-label form-control-label mt-0">
                  No Email
                </label>
                <input
                  type="checkbox"
                  name="noEmail"
                  className="mr-2"
                  checked={noEmail}
                  onChange={(e) => setNoEmail(e.target.checked)}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
              <button
                type="submit"
                className="btn btn-secondary me-2"
                onClick={() => onClose()}
              >
                Cancel
              </button>{" "}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => handleSave(e)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
